<div #bar class="pagetoolbar">
  <mat-icon>{{ icon }}</mat-icon>
  <h2>{{ label }}</h2>
</div>
